//@flow
import * as React from 'react';
import Button, { ButtonTypes } from 'common/components/core/button/Button';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import theme from './DownloadButton.scss';

class DownloadButton extends React.PureComponent {
    render() {
        const { onDownload, theme, label, className } = this.props;
        return (
            <Button
                theme={theme}
                className={classnames(theme.downloadButton, className)}
                icon="download"
                label={label}
                ripple={false}
                uppercase
                semibold
                buttonType={ButtonTypes.Link}
                onClick={onDownload}
            />
        );
    }
}

const ThemedDownloadButton = themr('DownloadButton', theme)(DownloadButton);
export { ThemedDownloadButton as DownloadButton };
export default ThemedDownloadButton;
